import React from 'react';
import classNames from 'classnames';
import {useI18n} from '../../contexts/I18n.client';
import {buttonClasses} from '../Button.client';
import {RoutePath} from 'utils/links';

type ProductFeatureProps = {
  title: string;
  body: string;
  image: React.ReactNode;
  position: number;
};

export const ProductFeature = (props: ProductFeatureProps) => {
  const {title, body, image, position} = props;

  const {t} = useI18n();

  return (
    <div
      className={classNames(
        'flex',
        'flex-col',
        'md:flex-row',
        {'md:flex-row-reverse': position % 2 === 0},
        'gap-11',
      )}
    >
      <div
        className={classNames(
          'md:w-1/2',
          'flex',
          'items-center',
          'justify-center',
        )}
      >
        {image}
      </div>

      <div
        className={classNames(
          'md:w-1/2',
          'flex',
          'items-center',
          'justify-center',
        )}
      >
        <div>
          <p
            className={classNames(
              'font-bold',
              'mb-4',
              'text-[2.125rem]',
              'md:text-5xl',
              'leading-[110%]',
              'md:leading-[120%]',
            )}
          >
            {title}
          </p>

          <p className={classNames('text-xl', 'leading-normal', 'mb-10')}>
            {body}
          </p>

          {/* TODO: Add tracking to this link */}
          <a
            className={classNames(buttonClasses, 'inline-block')}
            href={RoutePath.AuthSignup}
          >
            {t('common.signUpFree')}
          </a>
        </div>
      </div>
    </div>
  );
};
